export const INVITE_EMPLOYER_COUNT_TEST_ID = 'invite-employer-count-test-id';
export const INVITE_EMPLOYER_BTN_TEST_ID = 'invite-employer-btn-test-id';
export const INVITE_EMPLOYER_MODAL_CLOSE_BTN_TEST_ID = 'invite-employer-modal-close-btn-test-id';
export const INVITE_EMPLOYER_SPINNER_TEST_ID = 'invite-employer-spinner-test-id';
export const INVITE_EMPLOYER_MODAL_TEST_ID = 'invite-employer-modal-test-id';
export const INVITE_EMPLOYER_MODAL_NO_DATA_MESSAGE_TEST_ID = 'invite-employer-modal-no-data-message-test-id';
export const INVITE_EMPLOYER_MODAL_SPINNER_TEST_ID = 'invite-employer-modal-spinner-test-id';

export const EMPLOYER_BLOCK_TEST_ID = 'employer-block-test-id';
export const CLOSE_EDIT_EMPLOYER_FORM_BTN_TEST_ID = 'close-edit-employer-form-btn-test-id';
export const REINVITE_EMPLOYER_BTN_TEST_ID = 'reinvite-employer-btn-test-id';
export const EDIT_EMPLOYER_BTN_TEST_ID = 'edit-employer-btn-test-id';
export const REMOVE_EMPLOYER_BTN_TEST_ID = 'remove-employer-btn-test-id';
